import React from "react";
import PropTypes from "prop-types";

Badge.propTypes = {
  type: PropTypes.string.isRequired,
  badgeLabel: PropTypes.string.isRequired,
};

// I can't get react-bootstrap to work, so I'm using this as a workaround.
export function Badge({ type, badgeLabel }) {
  return <span className={`badge  bg-${type}`}>{badgeLabel}</span>;
}
